/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GlobalSocialComponent = {
  id?: number
  type?: GlobalSocialComponent.type
  url?: string
}
export namespace GlobalSocialComponent {
  export enum type {
    FACEBOOK = 'facebook',
    TWITTER = 'twitter',
    LINKEDIN = 'linkedin',
    INSTAGRAM = 'instagram',
  }
}
